module KendoWidgets
{
	export class SearchBarOptions
	{
		startingCollapsed?: boolean;
		icon?: string | boolean;
		width?: string | number;
		placeholder?: string;
		css?: string;

		onKeyUp?(e: SearchBarKeyUpEvent): void;
		onEnterKeyPress?(e: SearchBarEnterKeyPressEvent): void;
		onClick?(e: SearchBarClickEvent): void;
		onBlur?(e: SearchBarBlurEvent): void;
	}

	export class SearchBar extends kendo.ui.Widget implements KendoWidget
	{
		private _textBox: KendoWidgets.TextBox;
		private _previousValue: string;

		public controlType(): ControlTypeEnum { return ControlTypeEnum.SearchBar; }

		constructor(element: Element, options?: KendoWidgets.SearchBarOptions)
		{
			if (options == null)
				options = new KendoWidgets.SearchBarOptions();

			//#region Default options
			if (options.icon == null || options.icon == true) options.icon = IconClass.Search;
			if (options.startingCollapsed == null) options.startingCollapsed = false;
			if (options.placeholder == null) options.placeholder = "Cerca...";
			//#endregion

			(element as HTMLElement).classList.add("k-searchbar");
			$(element).css("display", "inline-block");
			super(element, options);
			let that = this;

			//#region Width
			if (typeof (options.width) == "number")
				options.width = options.width + "px";
			(element as HTMLElement).style.cssText += "width: " + options.width;
			//#endregion

			//#region Icon
			if (options.icon != false)
				$(element).append("<span id='" + element.id + "Icon' class='k-icon k-i-" + options.icon + "' style='cursor: pointer;'></span>");

			$("#" + element.id + "Icon").click(() =>
			{
				if (that.isCollapsed())
					that.expand();

				if (options!.onClick != null)
				{
					let clickEvent = new SearchBarClickEvent();
					clickEvent.value = that.value();
					options!.onClick(clickEvent);
				}
			});
			//#endregion

			//#region TextBox
			$(element).append("<input id='" + element.id + "TextBox' />");
			window.setTimeout(() =>
			{
				this._textBox = $("#" + element.id + "TextBox").kendoTextBox(
					{
						placeholder: options!.placeholder,
						onKeyPress: (e) =>
						{
							that._previousValue = that.value();
							if (e.enterKeyPressed && options!.onEnterKeyPress != null)
							{
								let enterKeyPressEvent = new SearchBarEnterKeyPressEvent();
								enterKeyPressEvent.value = that.value();
								options!.onEnterKeyPress(enterKeyPressEvent);
							}
						},
						onKeyUp: (e) =>
						{
							if (options!.onKeyUp != null)
							{
								let keyUpEvent = new SearchBarKeyUpEvent();
								keyUpEvent.value = that.value();
								keyUpEvent.previousValue = that._previousValue;
								options!.onKeyUp!(keyUpEvent);
							}
						},
						onBlur: (e) =>
						{
							if (options!.onBlur != null)
							{
								let blurEvent = new SearchBarBlurEvent();
								blurEvent.value = that.value();
								options!.onBlur(blurEvent);
							}
						}
					}).data("kendoTextBox");
			});
			//#endregion

			//#region Starting close
			if (options.startingCollapsed)
				this.collapse();
			//#endregion

			//#region CSS
			if (options.css != null)
				(element as HTMLElement).style.cssText += options.css;
			//#endregion
		}

		//#region Input
		value(text?: string)
		{
			return this._textBox.value(text);
		}

		clear()
		{
			if (this._textBox != null)
				this._textBox.clear();
		}
		//#endregion

		//#region Append
		appendTo(element: string | HTMLElement | JQuery)
		{
			this.element.appendTo(element);
		}

		prependTo(element: string | HTMLElement | JQuery)
		{
			this.element.prependTo(element);
		}
		//#endregion

		//#region Collapse/Expand
		collapse()
		{
			this._textBox.hide();
			this.element.css("border-bottom", "none");
		}

		expand()
		{
			this.element.css("border-bottom", "solid 1px #51B3E1");
			this._textBox.show();
		}

		isCollapsed()
		{
			return !this._textBox.visible();
		}
		//#endregion

		//#region Common
		focus()
		{
			this.element.find("input").focus();
		}
		//#endregion
	}

	//#region Events classes
	class SearchBarEvent
	{
		value: string;
	}

	class SearchBarKeyUpEvent extends SearchBarEvent
	{
		previousValue: string;
	}

	class SearchBarEnterKeyPressEvent extends SearchBarEvent
	{
	}

	class SearchBarClickEvent extends SearchBarEvent
	{
	}

	class SearchBarBlurEvent extends SearchBarEvent
	{
	}
	//#endregion

	//#region Icon Class
	export enum IconClass
	{
		Add = "plus",
		Close = "close",
		Delete = "close",
		Excel = "excel",
		Cancel = "undo",
		Prohibition = "cancel",
		Check = "check",
		Checked = "checkbox-checked",
		Checkbox = "checkbox",
		Edit = "edit",
		Refresh = "reload",
		Undo = "undo",
		Back = "undo",
		LinkHorizontal = "link-horizontal",
		UnlinkHorizontal = "unlink-horizontal",
		Attachment = "attachment",
		Print = "print",
		Filter = "filter",
		FilterClear = "filter-clear",
		Settings = "gear",
		SettingsKey = "wrench",
		Notification = "notification",
		List = "list-unordered",
		Formula = "formula-fx",
		Folder = "folder",
		Cloud = "cloud",
		Camera = "photo-camera",
		Pumo = "star",
		Image = "image",
		Resizing = "arrows-resizing",
		ArrowRight = "arrow-60-right",
		ArrowUp = "arrow-60-up",
		ArrowLeft = "arrow-60-left",
		ArrowDown = "arrow-60-down",
		Globe = "globe",
		GeoPin = "marker-pin-target",
		Share = "share",
		Save = "save",
		User = "user",
		Mail = "email",
		Circle = "circle",
		CheckedCircle = "radiobutton-checked",
		Preview = "preview",
		Group = "group",
		Search = "search",
		SortAsc = "sort-asc",
		SortDesc = "sort-desc",
		Zoom = "zoom",
		ZoomIn = "zoom-in",
		ZoomOut = "zoom-out",
		SplitVertically = "cell-split-vertically",
		Table = "table",
		FullScreen = "full-screen",
		ExitFullScreen = "full-screen-exit",
		News = "js",
		Information = "information",
		Warning = "warning",
		Question = "question",
		Status = "kpi-status-open",
		DocumentChange = "track-changes-enable",
		Rewind = "rewind-sm",
		Forward = "forward-sm",
		Layout = "layout",
		LayoutTableCell = "table-cell-properties"
	}
	//#endregion

	SearchBar.fn = SearchBar.prototype;
	SearchBar.fn.options = $.extend(true, {}, kendo.ui.Widget.fn.options);
	SearchBar.fn.options.name = "SearchBar";
	kendo.ui.plugin(SearchBar);
}

interface JQuery
{
	kendoSearchBar(options?: KendoWidgets.SearchBarOptions): JQuery;
	data(key: "kendoSearchBar"): KendoWidgets.SearchBar;
}